document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((item) => {
    const heading = item.querySelector(".item-heading");
    const content = item.querySelector(".item-content");
    heading.addEventListener("click", () => {
      const isActive = item.classList.contains("active");
      accordionItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("active");
          const otherContent = otherItem.querySelector(".item-content");
          otherContent.style.maxHeight = null;
        }
      });

      if (isActive) {
        item.classList.remove("active");
        content.style.maxHeight = null;
      } else {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});


